import { useSelector } from 'react-redux'
import { selectDefaultEmailAddress } from '@/features/domain/user'

export function useDefaultEmailAddress() {
  return useSelector(selectDefaultEmailAddress)
}
